import React from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingActions from "@/components/layout/FloatingActions";
import MinimalHeader from "@/components/layout/MinimalHeader";
import { useCheckoutStep } from "@/contexts/CheckoutStepContext";

function useLayoutMode() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/checkout")) return "checkout";
  if (pathname.startsWith("/order/")) return "confirmation";
  return "full";
}

/**
 * Renders either the standard site chrome (Header, Footer, FloatingActions) or
 * a slim confirmation-focused shell for `/checkout` and `/order/:orderNo`,
 * per the mockup. Site Header/Footer are untouched.
 */
export default function AppShell({ children }) {
  const mode = useLayoutMode();
  const { step } = useCheckoutStep();

  if (mode === "checkout") {
    return (
      <>
        <MinimalHeader variant="checkout" activeStep={step} />
        <main className="flex-1 bg-[#F5F3FB]">{children}</main>
      </>
    );
  }

  if (mode === "confirmation") {
    return (
      <>
        <MinimalHeader variant="confirmation" />
        <main className="flex-1 bg-[#F5F3FB]">{children}</main>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="flex-1">{children}</div>
      <Footer />
      <FloatingActions />
    </>
  );
}
